import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5013/api/v1';

function authHeaders() {
  const token = localStorage.getItem('knkt_crm_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const campaignsApi = {
  getAll: () =>
    axios.get(`${BASE}/campaigns`, { headers: authHeaders() }).then(r => r.data),

  getOne: (id) =>
    axios.get(`${BASE}/campaigns/${id}`, { headers: authHeaders() }).then(r => r.data),

  create: (data) =>
    axios.post(`${BASE}/campaigns`, data, { headers: authHeaders() }).then(r => r.data),

  update: (id, data) =>
    axios.patch(`${BASE}/campaigns/${id}`, data, { headers: authHeaders() }).then(r => r.data),
};
